import { TloginErrorResponse } from "@/services/post-login-sso"
import { Err } from "@pacote/result"
import { useCustomSearchParams } from "./use-search-params"

export const useLoginError = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSearchParams] = useCustomSearchParams()

  const handleLoginError = (
    errorResponse: Err<TloginErrorResponse>,
    setFormError: (message: string) => void,
  ) => {
    switch (errorResponse.value.type) {
      case "SOGEI":
        setSearchParams((prevParams) => {
          prevParams.set("errorBanner", "sogei")
          return prevParams
        })
        return
      case "NO-AUTO-LIMITATION-SET":
        setSearchParams((prevParams) => {
          prevParams.set("errorBanner", "noAutoLimitationSet")
          return prevParams
        })
        return

      case "CONTRACT-NOT-ACCEPTED":
        setSearchParams((prevParams) => {
          prevParams.set("errorBanner", "contractNotAccepted")
          return prevParams
        })
        return
      case "CREDENTIALS":
        setFormError(`Errors.invalidCredentials.${errorResponse.value.counter}`)
        return
      case "ERROR_RECAPTCHA":
        setFormError("Errors.recaptcha")
        return
      default:
        setSearchParams((prevParams) => {
          prevParams.set("errorBanner", "serviceError")
          return prevParams
        })
        return
    }
  }

  return {
    handleLoginError,
  }
}
